/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidationErrorResponse
 */
export interface ValidationErrorResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ValidationErrorResponse
     */
    errors: { [key: string]: string; };
}

/**
 * Check if a given object implements the ValidationErrorResponse interface.
 */
export function instanceOfValidationErrorResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function ValidationErrorResponseFromJSON(json: any): ValidationErrorResponse {
    return ValidationErrorResponseFromJSONTyped(json, false);
}

export function ValidationErrorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationErrorResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': json['errors'],
    };
}

export function ValidationErrorResponseToJSON(value?: ValidationErrorResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errors': value.errors,
    };
}

